export { default as actions, key } from './actions';
export { default as reducer, selectors } from './reducer';
// export { default as logic } from './logic';



// WEBPACK FOOTER //
// ./src/util/redux/patientList/index.js